import { render, staticRenderFns } from "./PDA_Issues.vue?vue&type=template&id=9c97c890"
import script from "./PDA_Issues.vue?vue&type=script&lang=js"
export * from "./PDA_Issues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports